module.exports = __webpack_public_path__ + "static/media/lp-img-2.6c93ea02.png";